import React from 'react';
import { Steps } from 'react-step-builder';
import { useHistory } from 'react-router-dom';
import { MultiStepForm } from '../../../components';
import {
  BulkEmailConfirmation,
  BulkEmailDateSelection,
  BulkEmailDocumentsSelection,
  BulkEmailIncludeStakeholders,
  BulkEmailInsuredsSelection
} from '../components';
import { useBulkEmailDocumentFormSteps } from '../hooks';
import { useSendDocumentsJobContext } from '../../../context';
import { SERVER_SIDE_DATE_FORMAT } from '../../../utils/dates';
import moment from 'moment';

export default function BulkEmail({ policyId, clientId, redirectUrl, initialState }) {
  const history = useHistory();
  const { startSendDocumentsJob, loading, error } = useSendDocumentsJobContext();
  const { loading: initialLoading, error: initialError, allData } = initialState;

  const { formSteps } = useBulkEmailDocumentFormSteps(initialState);

  const onSubmit = values => {
    const { activeOn, includeStakeholders, documentIds, insuredIds } = values;

    const filteredForDocuments = allData.filter(x => documentIds.includes(x.documentId));
    const filteredForInsureds = filteredForDocuments.filter(x => insuredIds.includes(x.insuredId));
    const documentRelationshipIds = filteredForInsureds.map(x => x.documentRelationshipId);

    startSendDocumentsJob({
      activeOn: activeOn === '' ? null : moment(activeOn).format(SERVER_SIDE_DATE_FORMAT),
      clientId,
      policyId,
      documentRelationshipIds,
      includeStakeholders,
      redirectUrl
    });
  };

  return (
    <MultiStepForm
      formSteps={formSteps}
      formSubmit={onSubmit}
      maxWidth={'800px'}
      title={`Send Bulk Email`}
      onCancel={() => history.push(redirectUrl)}
      submitButtonText={'Send'}
      submitButtonProps={{ loading, loadingText: 'Sending...' }}
      showButtonsOnBottom
      loading={initialLoading}
      error={initialError || error}
    >
      {formProps => (
        <Steps>
          <BulkEmailDateSelection {...formProps} />
          <BulkEmailIncludeStakeholders {...formProps} />
          <BulkEmailDocumentsSelection {...formProps} clientId={clientId} policyId={policyId} />
          <BulkEmailInsuredsSelection {...formProps} clientId={clientId} policyId={policyId} />
          <BulkEmailConfirmation {...formProps} />
        </Steps>
      )}
    </MultiStepForm>
  );
}
